export const DEFAULT_READY_OPTIONS = {
    disableNativeGestures: false,
};
